import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { productFields } from './common/productFields';
import { msg } from '@lingui/core/macro';
import { massUnitField } from './common/sharedFields';

export const microplasticsOutflowMetadata = {
  displayName: msg({
    message: 'Microplastics outflow',
    context: 'Activity data schema name for microplastics outflow',
  }),
  fields: {
    ...coreFields,
    ...productFields,
    microplastics_outflow_medium: {
      displayName: msg({
        message: 'Microplastics outflow medium',
        context: 'The medium through which the microplastics are released.',
      }),
      externalDescription: msg({
        message: 'The medium through which the microplastics are released.',
        context: 'Microplastics outflow medium',
      }),
    },
    quantity: {
      displayName: msg({
        message: 'Microplastics quantity',
        context: 'The quantity of microplastics released.',
      }),
      externalDescription: msg({
        message: 'The quantity of microplastics released.',
        context: 'Microplastics quantity',
      }),
    },
    unit: massUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
